module.exports = (__webpack_require__(66))("./node_modules/@apollo/client/utilities/index.js");